import type { WizardFlowDefinition } from '../flowTypes';
import CancelStartStep from '../../components/cancel/CancelStartStep';
import CancelSmsStep from '../../components/cancel/CancelSmsStep';
import CancelInfoStep from '../../components/cancel/CancelInfoStep';
import CancelConfirmationStep from '../../components/cancel/CancelConfirmationStep';

const cancelPhases = [
  { id: 'intro', name: 'Start' },
  { id: 'verify', name: 'Bekræft' },
  { id: 'completion', name: 'Afslut' }
] as const;

const cancelFlow: WizardFlowDefinition = {
  id: 'afbestil',
  startStep: 'bk_start',
  phases: cancelPhases,
  steps: {
    bk_start: { id: 'bk_start', name: 'Afbestil', component: CancelStartStep, next: 'bk_sms', phase: 'intro' },
    bk_sms: { id: 'bk_sms', name: 'SMS-kode', component: CancelSmsStep, next: 'bk_info', phase: 'verify' },
    bk_info: { id: 'bk_info', name: 'Bekræft', component: CancelInfoStep, next: 'bk_confirmation', phase: 'verify' },
    bk_confirmation: { id: 'bk_confirmation', name: 'Bekræftelse', component: CancelConfirmationStep, phase: 'completion' }
  }
};

export { cancelFlow };
